import React, { FC, ReactNode } from 'react';
import './ActionButton.css';
import { FaSpinner } from '@/Shared';

interface ActionButtonProps {
	onClick?: () => void;
	label?: string;
	icon?: ReactNode;
	classNames?: string;
	isLoading?: boolean;
	tooltip?: string;
	showLabel? : boolean;
	disabled? : boolean;
	type? : "button" | "submit"
}

/**
 * =====================================================
 * ActionButton
 * =====================================================
 *
 * Renders a clickable button with optional icon, loading state, tooltip,
 * label, and CSS class customization. Handles click events safely by
 * preventing default browser behavior and stopping propagation.
 *
 * @param props - Component props
 * @returns A React button element for UI actions
 *
 * Author: Samano CASTRE
 * Date: February 27, 2026
 */
const ActionButton: FC<ActionButtonProps> = ({
	label,
	onClick,
	icon,
	classNames = "",
	isLoading,
	tooltip = "Bouton d'action",
	showLabel=false,
	disabled,
	type="button"
}) => {

	return (
		<button
			disabled = {disabled}
		    type={type}
			className={'ActionButton button with-icon ' + classNames}
			aria-label={tooltip}
			data-testid="ActionButton"
			title={tooltip}
			{...(onClick ? { 
				onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
					event.preventDefault();
					event.stopPropagation();
					onClick();
				} 
			} : {})}
			>
			{isLoading ? <FaSpinner className='spinner' /> : icon}
			{label && showLabel && <span>{label}</span>}

		</button>
	);
}

export default ActionButton;
